export enum EOrderScheduleMainTabs {
	GENERAL = 'general',
	LIMITATIONS = 'limitations',
}

export enum EOrderScheduleTypes {
	ORDER_DEADLINE = 'ORDER_DEADLINE',
	CHANGE_ADDRESS_DEADLINE = 'CHANGE_ADDRESS_DEADLINE',
}

export enum EOrderScheduleDays {
	MONDAY = 0,
	TUESDAY = 1,
	WEDNESDAY = 2,
	THURSDAY = 3,
	FRIDAY = 4,
	SATURDAY = 5,
	SUNDAY = 6,
}
